import { FC, ReactNode } from 'react'
import { useLocation } from 'react-router'
import ROUTES from '@client-hub/shared/constants/routes'
import { useUserHasRoutePermission } from '@client-hub/shared/react/hooks/useUserHasRoutePermission'
import HubNotFound from './HubNotFound'

const PermissionGaurd: FC<{ children?: ReactNode }> = (props) => {
  const { pathname } = useLocation()
  const hasPermission = useUserHasRoutePermission(pathname)
  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (hasPermission) return <>{props.children}</>

  return <HubNotFound returnToHomeLink={ROUTES.BASE} />
}

export default PermissionGaurd
